import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { BatchTypeFormValues } from "src/models/BatchType.model";

type Props = {
  formikProps: FormikProps<BatchTypeFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const BatchTypeForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Batch Type" : "Update Batch Type"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="batchTypeName"
            value={values.batchTypeName}
            required
            onChange={(e) => {
              setFieldValue("batchTypeName", e.target.value);
            }}
            label="Batch Type Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="batchTypeCode"
            value={values.batchTypeCode}
            required
            onChange={(e) => {
              setFieldValue("batchTypeCode", e.target.value);
            }}
            label="Batch Type Code"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default BatchTypeForm;
